'use strict';

var account = require('./account'),
    bonusProductsView = require('../bonus-products-view'),
    quickview = require('../quickview'),
    progress = require('../progress'),
    cartStoreInventory = require('../storeinventory/cart'),
    page = require('../page'),
    util = require('../util');

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    $('button[id*=applyprice]').on('click', function (e) {
        e.preventDefault();
        var reason, uuid, standardPrice, unitPrice, url, pid;
        pid = $(this).closest('.oob-table').data('pid');
        uuid = this.name.split('-')[1];
        if ($('#select-reason-'+uuid).val() === "") {
            $('#select-reason-'+uuid).removeClass('valid');
            $('#select-reason-'+uuid).addClass('invalid');
            $('#select-reason-'+uuid).attr('aria-invalid', 'true');
            reason = "";
            return;
        } else {
            $('#select-reason-'+uuid).removeClass('invalid');
            $('#select-reason-'+uuid).addClass('valid');
            $('#select-reason-'+uuid).attr('aria-invalid', 'false');
            reason = $('#select-reason-'+uuid).val();
        }
        if ($('#unitprice-'+uuid).val() === "") {
            unitPrice = $('#unitprice-'+uuid).attr('max');
            standardPrice = $('#unitprice-'+uuid).data('standardPrice');
        } else {
            $('#unitprice-'+uuid).removeClass('invalid');
            $('#unitprice-'+uuid).addClass('valid');
            $('#unitprice-'+uuid).attr('aria-invalid', 'false');
            unitPrice = $('#unitprice-'+uuid).val();
            standardPrice = $('#unitprice-'+uuid).data('standardPrice');
        }
        url = this.dataset.url;
        $.ajax(url, {
            type:'POST',
            data: {
                pid: pid,
                uuid: uuid,
                reason: reason,
                unitPrice: unitPrice,
                standardPrice: standardPrice            },
            dataType: 'json',
            success:function(response){
                if (!response.success) {
                    alert(response.message);
                    progress.hide();
                    reinit();
                } else {
                    progress.hide();
                    page.redirect(Urls.cartShow);
                }
            },
            error: function (e) {
                alert("There was some problem with the request. Please try again");
                progress.hide();
                reinit();
            }
        });
    });
    $('select[id*=select-reason]').on('change', function(){
        var new_selection = $(this).find('option:selected');
        $(this).find('option').not(new_selection).removeAttr('selected');
        new_selection.attr("selected",true);
        $(this).removeClass('invalid');
    });
    $('#cart-items-form').on('click', '.item-edit-details > a', function (e) {
        e.preventDefault();
        quickview.show({
            url: e.target.href,
            source: 'cart',
            className:'hide-find-store-button'
        });
    });
    $('#cart-items-form, .bonus-item-promo').on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
    });

    // override enter key for coupon code entry
    $('form input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13) {
            if ($(this).val().length === 0) {
                return false;
            } else {
                e.preventDefault();
                $('.cart-coupon-code__button').trigger('click');
            }
        }
    });

    function submitTaxEstimationPostalCode() {
        var $postalCode = $('.cart-tax-estimation-postal-code__input');
        var postalVal = $postalCode.val();
        if (postalVal.length >= 6) {
            let $postalCodeContainer = $postalCode.closest('.cart-tax-estimation-postal-entry');
            let actionUrl = $postalCodeContainer.attr('data-action-url');
            actionUrl = util.ajaxUrl(actionUrl.replace('postal_param_value', postalVal));
            $.ajax({
                url: actionUrl,
                type: 'GET'
            }).done(function (response) {
                if ('province' in response && response.province.length) {
                    page.redirect(Urls.cartShow);
                } else {
                    $('.cart-tax-estimation-postal-code__error').addClass('visible-error');
                }
            }).fail(function (xhr, textStatus) {
                $('.cart-tax-estimation-postal-code__error').addClass('visible-error');
            });
        } else {
            $('.cart-tax-estimation-postal-code__error').addClass('visible-error');
        }
    }

    $('.cart-tax-estimation-postal-code__button').on('click', function (e) {
        e.preventDefault();
        submitTaxEstimationPostalCode();
    });
    $('.cart-tax-estimation-postal-code__input').on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            submitTaxEstimationPostalCode();
        }
    });

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;
    $('button[name$="deleteProduct"]').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
        }
    });
    $('.quantity input').on('change', function() {
        var $qtyUpdateCartButton = $(this).parent().siblings('.update-cart');
        if ($qtyUpdateCartButton.hasClass('js-qty-auto-submit')) {
            // functionality for cart page to auto-submit the form when the quantity is changed
            let qtyNumber = Number($(this).val());
            if (isNaN(qtyNumber)) {
                return;
            }
            let $lineItem = $(this).closest('.cart-lineitem');
            let activeATS = Number($(this).data('active-ats'));
            $lineItem.removeClass('qty-inventory-exceeded');
            if (qtyNumber < 1) {
                $qtyUpdateCartButton = $lineItem.find('.remove-lineitem-button');
            }

            if (activeATS < qtyNumber && $lineItem.length) {
                $lineItem.addClass('qty-inventory-exceeded');
            } else if (qtyNumber !== Number($(this).data('initial-qty'))) {
                // only trigger the click if the quantity has changed
                $qtyUpdateCartButton.trigger('click');
            }
        } else {
            $qtyUpdateCartButton.removeClass('d-none');
        }
    });

    function stickyCheckoutActions() {
        let $checkoutButtonWrapper = $('.sticky-actions');
        let $returnToTop = $('#return-to-top');
        if ( $('.cart-actions-form').offset().top > ($(window).scrollTop() + $(window).height() - 20)) {
            $checkoutButtonWrapper.addClass('sticky');
            if ($returnToTop.length) {
                $returnToTop.addClass('has-sticky-checkout-actions');
            }
        } else {
            $checkoutButtonWrapper.removeClass('sticky');
            if ($returnToTop.length) {
                $returnToTop.removeClass('has-sticky-checkout-actions');
            }
        }
    }
    $(window).on('scroll resize', stickyCheckoutActions);
    //initial call after page load
    setTimeout(stickyCheckoutActions, 1000);


    $('.dismiss-message-button').on('click', function (e) {
        $(this).closest('.floating-message').remove();
    });
    setTimeout(function () {
        // automatically remove floating messages 10 seconds after the page loads
        $('.floating-message').remove();
    }, 10000);
}
/**
* @private
* @function
* @description Initialize additional functionality related with PayPal integration
*/
function initPaypalFunctionality() {
    var dialog = require('../dialog');
    var $expressButton = $('.js_paypal_start_ba_checkout');

    $expressButton.on('click', function() {
        if($expressButton.data('is-address-exist') === true) {
            return true;
        }
        dialog.open({
            url: $expressButton.data('edit-address-url'),
            options: {
                title: $expressButton.data('edit-address-title'),
                open: initEditDefaultShippingAddressForm
            },
        });
        return false;
    });

    function initEditDefaultShippingAddressForm() {
        var $form = $('#paypalEditDefaultShippingAddress');
        $form.on('click', '.apply-button', function() {
            if (!$form.valid()) {
                return false;
            }
            var applyName = $form.find('.apply-button').attr('name');
            var options = {
                url: $form.attr('action'),
                data: $form.serialize() + '&' + applyName + '=x',
                type: 'POST'
            };
            $.ajax(options).done(function(data) {
                if (typeof(data) !== 'string') {
                    if(data.success) {
                        dialog.close();
                        window.location = $expressButton.attr('href');
                    } else {
                        window.alert(data.message);
                        return false;
                    }
                } else {
                    $('#dialog-container').html(data);
                    initEditDefaultShippingAddressForm();
                }
            });
            return false;
        });
        $form.on('click', '.cancel-button, .close-button', function() {
            dialog.close();
            return false;
        });
        $('#paypalSelectSavedAddress').change(function() {
            var data = $(this).val();
            try {
                data = JSON.parse(data);

                for(var addressName in data) {
                    var val = data[addressName];
                    if(typeof val === 'string') {
                        val = val.replace(/\^/g,"'");
                    }
                    $('#dwfrm_profile_address_' + addressName).val(val);
                }
            } catch(e) {
                $form.find('input:text').val('');
                $form.find('select').val('');
            }
        });
    }
}

function reinit() {
    initializeEvents();
    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
    account.initCartLogin();
    initPaypalFunctionality();
}

exports.init = function () {
    initializeEvents();
    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
    account.initCartLogin();
    initPaypalFunctionality();
};
